/**
 * Puschies Footer (sections/p-footer.liquid)
 * - <p-footer-accordion>: Menü-Spalten ab 1024 px immer offen, darunter Akkordeon (zu, außer data-open-default="true").
 * - <p-footer-country>: Länder-Dropdown; Auswahl setzt country_code und schickt das native Localization-Formular ab.
 */
const desktopQuery = window.matchMedia('(min-width: 1024px)');

class PFooterAccordion extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;
    this.openDefault = this.dataset.openDefault === 'true';
    this.sync = () => {
      this.details.open = desktopQuery.matches || this.openDefault;
    };
    this.sync();
    desktopQuery.addEventListener('change', this.sync);
    // Desktop: Spalten bleiben offen (auch per Tastatur nicht zuklappbar)
    this.details.querySelector('summary')?.addEventListener('click', (event) => {
      if (desktopQuery.matches) event.preventDefault();
    });
    this.setAttribute('data-ready', '');
  }

  disconnectedCallback() {
    if (this.sync) desktopQuery.removeEventListener('change', this.sync);
  }
}

class PFooterCountry extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-toggle]');
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[name="country_code"]');
    if (!this.toggle || !this.form || !this.input) return;

    this.onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.setOpen(false);
    };
    this.onKeydown = (event) => {
      if (event.key !== 'Escape') return;
      this.setOpen(false);
      this.toggle.focus();
    };

    this.toggle.addEventListener('click', () => {
      this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true');
    });
    this.querySelectorAll('[data-value]').forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        this.input.value = option.dataset.value;
        this.form.submit();
      });
    });
  }

  disconnectedCallback() {
    this.setOpen(false);
  }

  setOpen(open) {
    if (!this.toggle) return;
    this.toggle.setAttribute('aria-expanded', String(open));
    this.toggleAttribute('open', open);
    const method = open ? 'addEventListener' : 'removeEventListener';
    document[method]('click', this.onDocumentClick);
    document[method]('keydown', this.onKeydown);
  }
}

if (!customElements.get('p-footer-accordion')) customElements.define('p-footer-accordion', PFooterAccordion);
if (!customElements.get('p-footer-country')) customElements.define('p-footer-country', PFooterCountry);
